// Hero
export const HERO_OPACITY = 'opacity-50';
export const HERO_TINT = 'dark-30';
export const HERO_COLOR = 2;
